import styled, { css } from 'styled-components';
import Icon, { ICON_SIZES, IconContainer } from '@anwb/icon';
import Link, { LinkAnchor, LinkLabel, LinkSubText } from '@anwb/link';
import { stylePropertiesToCss } from '@anwb/style-mixins';
import { pxToRem } from '@anwb/style-utilities';
import { ComponentSubtitle, ComponentTitle } from '@anwb/typography';
import { getGenericPanelPadding } from '../../../styles/helpers';
/**
 * PanelHeaderContainerShared
 */
export const panelHeaderContainerSharedStyles = ({ theme, $hasSubTitle, }) => css `
	padding: ${pxToRem(theme.spacing['200'])};
	padding-bottom: 0;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		padding: ${pxToRem(theme.spacing['300'])};
		padding-bottom: 0;
	}

	${$hasSubTitle &&
    css `
		padding-bottom: 0 !important;
	`}
`;
/**
 * PanelHeaderLinkContainer
 */
export const panelHeaderLinkContainerStyles = ({ theme, $hasSpacing, }) => css `
	display: block;
	margin-right: 0;

	${!$hasSpacing &&
    css `
		&& {
			span {
				margin-bottom: 0;
			}
		}
	`}

	${LinkAnchor} {
		display: block;
	}

	${LinkLabel} {
		position: relative;
		display: block;
		margin-right: ${pxToRem(ICON_SIZES.md + Number(theme.spacing['200']))};
		margin-bottom: ${pxToRem(theme.spacing['100'])};
		hyphens: auto;

		${stylePropertiesToCss(theme.typography.heading4['300ComponentTitle'])}

		${IconContainer}:not(${PanelHeaderIcon}) {
			position: absolute;
			height: auto;
			font-style: normal;
		}

		> * {
			vertical-align: middle;
		}
	}

	${LinkSubText} {
		hyphens: auto;

		${stylePropertiesToCss(theme.typography.heading5['200ComponentSubTitle'])}
	}
`;
export const PanelHeaderLinkContainer = styled(Link) `
	${panelHeaderContainerSharedStyles}
	${panelHeaderLinkContainerStyles}
`;
/**
 * PanelHeaderContainer
 */
export const panelHeaderContainerStyles = ({ theme, }) => css `
	${ComponentTitle} {
		margin-bottom: ${pxToRem(theme.spacing['100'])};
	}

	${ComponentSubtitle} {
		margin-bottom: 0; // Remove default margin bottom from typography
	}
`;
export const PanelHeaderContainer = styled.div `
	${panelHeaderContainerSharedStyles}
	${panelHeaderContainerStyles}
`;
export const panelHeaderIconStyles = ({ theme }) => css `
	margin-bottom: 0;
	margin-right: ${pxToRem(theme.spacing['200'])};
`;
export const PanelHeaderIcon = styled(Icon).attrs({
    type: 'illustrative',
    size: 'xxxl',
}) `
	${panelHeaderIconStyles}
`;
export const panelHeaderContentStyles = () => css `
	${getGenericPanelPadding(['right', 'left'])}
`;
export const PanelHeaderContentContainer = styled.div `
	${panelHeaderContentStyles}
`;
//# sourceMappingURL=panel-header.styled.js.map